import * as yup from 'yup';
import { IncrementingStatBlock } from '@web/components';

export const component = IncrementingStatBlock;

export const schema = yup
  .object({
    finalValue: yup.number().required(),
    suffix: yup.string(),
    prefix: yup.string(),
    textColor: yup.string(),
    backgroundColor: yup.string(),
    description: yup.string(),
    initialValue: yup.number().nullable(),
    increment: yup.number().nullable(),
    speed: yup.number().nullable(),
  })
  .transform(value => ({
    finalValue: parseFloat(value.final_value),
    suffix: value.suffix,
    prefix: value.prefix,
    textColor: value.text_color || undefined,
    backgroundColor: value.background_color || undefined,
    description: value.description,
    initialValue: value.initial_value
      ? parseFloat(value.initial_value)
      : undefined,
    increment: value.increment ? parseFloat(value.increment) : undefined,
    speed: value.speed ? parseFloat(value.speed) : undefined,
  }));
